export default "__VITE_ASSET__DlcHr4Au__"